import { useContext } from "react";
import ServiceDetailPage from "../../ones/ServiceDetailPage";
import Footer from "../../ones/Footer";
import { AppContext } from "../../App";
import { dropdownContent } from "../../data/menuDropdowns";
import image1 from "../../assets/mtkili.jpg";
import image2 from "../../assets/acc.jpg";
import image3 from "../../assets/summit.jpg";

const trekkingRoutes = dropdownContent.trekking ?? [];

const trekkingPackageMeta = {
  kilimanjaro: {
    duration: "8-9 Days | 7-8 Nights",
    travellers: "Travellers 2+",
    imagePosition: "center 46%",
  },
  machame: {
    duration: "7 Days | 6 Nights",
    travellers: "Travellers 2+",
    imagePosition: "center 58%",
  },
  lemosho: {
    duration: "7-8 Days | 6-7 Nights",
    travellers: "Travellers 2+",
    imagePosition: "center 30%",
  },
  rongai: {
    duration: "7 Days | 6 Nights",
    travellers: "Travellers 2+",
    imagePosition: "center 42%",
  },
};

export default function ServiceSunflower() {
  const appContext = useContext(AppContext);

  function handleRouteNavigation(nav) {
    if (!nav) return;
    appContext.navTo(nav);
  }

  const trekkingPackages = trekkingRoutes.map((card) => {
    const subItem = card.nav?.subItem || "";
    const meta = trekkingPackageMeta[subItem] || {};

    return {
      badge: "Trekking",
      title: card.title,
      description: card.text,
      duration: meta.duration || "Custom itinerary",
      travellers: meta.travellers || "Travellers 2+",
      image: card.img,
      imageAlt: card.title,
      imagePosition: meta.imagePosition || "center",
      nav: card.nav,
      onClick: () => handleRouteNavigation(card.nav),
      ctaLabel: "View Route",
    };
  });

  return (
    <>
      <ServiceDetailPage
        label="Trekking"
        title="Trekking"
        subtitle="The Roof of Africa at 5,895 meters, climbed with expert support, route strategy, and premium mountain logistics."
        overview="Mount Kilimanjaro is Africa's highest peak and one of the world's most iconic trekking adventures. Unlike technical summits, Kilimanjaro is accessible to determined first-time and experienced hikers with proper preparation. Routes such as Machame, Lemosho, Marangu, Rongai, and the Northern Circuit pass through rainforest, moorland, alpine desert, and finally the snow-capped summit. The journey is defined by changing climate zones, sunrise views above cloud level, and strong guiding teams. With carefully structured itineraries, camp comfort, and acclimatization-focused pacing, climbers can safely pursue Uhuru Peak and a life-changing summit experience."
        images={[
          {
            src: image1,
            alt: "Kilimanjaro trek team",
            captionTitle: "The Roof of Africa",
            captionText: "A high-altitude expedition across dramatic ecological zones.",
          },
          {
            src: image2,
            alt: "Kilimanjaro mountain camp",
            captionTitle: "Acclimatization Strategy",
            captionText: "Thoughtful pacing and camp progression to support summit success.",
          },
          {
            src: image3,
            alt: "Kilimanjaro summit view",
            captionTitle: "Summit Achievement",
            captionText: "Guided ascent to Uhuru Peak with full mountain support.",
          },
        ]}
        highlights={[
          "Guided non-technical climb model for ambitious first-time trekkers.",
          "Full mountain crew, camp logistics, and safety-first operations.",
          "Route-specific acclimatization planning and daily pace control.",
          "Pre-climb briefing, gear guidance, and transfer coordination.",
        ]}
        metrics={[
          { value: "5,895m", label: "Summit elevation" },
          { value: "6 Routes", label: "Trekking options" },
          { value: "6-9 Days", label: "Route durations" },
        ]}
        packageHeading="Our Kilimanjaro Trekking Packages"
        packages={trekkingPackages}
        ctaLabel="Plan My Kilimanjaro Trek"
      />
      {trekkingRoutes.length > 0 && (
        <section className="MainBodySection" style={{ paddingBottom: 60 }}>
          <div className="container">
            <div className="mx-auto text-center" style={{ maxWidth: 820 }}>
              <p className="text-uppercase" style={{ fontSize: 12, letterSpacing: 1.4, color: "#b07d2e" }}>
                Trekking Navigation
              </p>
              <h2 className="font-bold mb-2" style={{ color: "#132335", fontSize: "clamp(24px, 3vw, 32px)" }}>
                Choose a route and explore detailed logistics
              </h2>
              <p className="mb-0" style={{ color: "#4f5f72", lineHeight: 1.6 }}>
                These are the same routes highlighted in the Trekking dropdown, each linking directly to the
                Kilimanjaro itinerary that best matches its navigation entry.
              </p>
            </div>

            <div className="row g-4 mt-4">
              {trekkingRoutes.map((card) => (
                <div className="col-12 col-md-6 col-xl-3" key={card.title}>
                  <article
                    className="mega-card"
                    role="button"
                    tabIndex={0}
                    aria-label={`Explore ${card.title}`}
                    onClick={() => handleRouteNavigation(card.nav)}
                    onKeyDown={(event) => {
                      if (event.key === "Enter" || event.key === " ") {
                        event.preventDefault();
                        handleRouteNavigation(card.nav);
                      }
                    }}
                  >
                    <div className="mega-card-image" style={{ backgroundImage: `url(${card.img})` }} />
                    <div className="mega-card-overlay" />
                    <div className="mega-card-content">
                      <h6>{card.title}</h6>
                      <p>{card.text}</p>
                      <button
                        type="button"
                        className="btn btn-light btn-sm"
                        onClick={(event) => {
                          event.stopPropagation();
                          handleRouteNavigation(card.nav);
                        }}
                      >
                        Explore Route
                      </button>
                    </div>
                  </article>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
      <Footer />
    </>
  );
}
